// src/i18n/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const supportedLngs = ['pt', 'en', 'es'];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs,
    fallbackLng: 'pt',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'selectedLanguage', 
      caches: ['localStorage']
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },

    defaultNS: 'translation',
    
    react: {
      useSuspense: true,
    },
    debug: false,
    
    interpolation: {
      escapeValue: false, 
    }
  });

export default i18n;